import React from "react";
import { Facebook, Twitter, Instagram } from "lucide-react";
import { SITE } from "../../data/content";

export default function SocialIconsBox() {
  return (
    <div className="flex items-center justify-center gap-4 bg-white border border-[#d6dcb6] py-3">
      <a href={SITE.facebook} target="_blank" rel="noreferrer" className="text-[#7d8e54] hover:text-[#5b6a37]" aria-label="Facebook">
        <Facebook className="w-6 h-6" />
      </a>
      <a href={SITE.twitter} target="_blank" rel="noreferrer" className="text-[#7d8e54] hover:text-[#5b6a37]" aria-label="Twitter">
        <Twitter className="w-6 h-6" />
      </a>
      <a href={SITE.instagram} target="_blank" rel="noreferrer" className="text-[#7d8e54] hover:text-[#5b6a37]" aria-label="Instagram">
        <Instagram className="w-6 h-6" />
      </a>
    </div>
  );
}
